import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import clsx from 'clsx';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import {useStylesTooltip} from "../../../../../config/theme";

const useStyles = makeStyles(() => ({
  header: {
    background: '#fff',
    borderRadius: '10px 10px 0px 0px',
    position:'sticky',
    top:-20,
    zIndex:2,
  },
  headerContent: {
    height: 65,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#606B76',
    fontSize: 12,
    borderBottom: '1px solid #D9D9D9',
    textTransform: 'uppercase',
    '& div': {
      textAlign: 'left'
    },
  },
  p8: {
    padding: '0 8px'
  },
  headerName: {
    color: '#017AEF',
    display: 'flex',
    justifyContent: 'space-between',
  },
  rotate180: {
    transform: 'rotate(180deg)',
  },
  subClass: {
    height: 40, 
    background: '#E4E9EF',
    padding: '0 8px'
  },
  searchClass: {
    height: 65,
  },
  cursor: {
    cursor: 'pointer',        
  },
   visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  reelsMainHeader:{
    "& > div:nth-child(3) > span":{
      justifyContent:"flex-start"
    },
    "& > div:nth-child(2) > span":{
      justifyContent:"flex-start"
     },
    "& > div > span":{
      width:"97%"
    },
    "& > div > span > div":{
      right:"10px",
    }
  },
  reelsSubHeader:{
    "& > div:nth-child(2) > span":{
      justifyContent:"flex-start"
     },
    "& > div > span":{
      width:"97%"
    },
    "& > div > span > div":{
      right:"10px",
    }
  }
}));

const CustomSortIconComponent = (order:string,orderBy:string,id:any) => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        marginLeft:10,
        right: theme.spacing(-1),         
        width: 14,
        top: order ? 1 : 0
      },
      icon: {
        width: '100%',
        height: '100%',
        transform: order ? 'rotate(180deg)' : ''
      }
    }),
  );

  const classes = useStyles();

  return (
    (orderBy === id && orderBy !== '') ? (
      <div className={classes.root}>
      <img className={classes.icon} src={'/assets/icons/sort.svg'} alt='sort icon' />
    </div>
    ) : (<></>)
  )
};

export function CreatorReelsTableHeader(props: any) {
  const classes = useStyles();
  const tooltipClasses = useStylesTooltip();
  const { onClickFilter, filterDirection, data, sub, search, filter, topPosition, isMobile, mainHeader } = props;

  const isNotSortLabel = (item: any) => {
    return item.title.toLowerCase() == 'experiences in reel'
      || item.title.toLowerCase() == 'id'
      || item.title.toLowerCase() == 'survey'
      || item.title.toLowerCase() == 'participants'
  };

  return (
    <div
      className={clsx(classes.header, !sub && classes.p8)}
      style={{top: (topPosition !== undefined ? topPosition : -20), borderRadius: isMobile && 0}}
    >
      <div className={clsx(classes.headerContent, (search && sub) && classes.searchClass, sub && classes.subClass) + ` ${mainHeader === true ? classes.reelsMainHeader: classes.reelsSubHeader} `}>
        {
          data.map((item: any, index: number) =>
            isNotSortLabel(item) ? (
              <div key={index} style={{ width: item.width }}>
                {item.title === 'survey' && (
                  <Tooltip classes={tooltipClasses} title="Survey Included in Experience" placement="bottom" arrow>
                    <img src={'/assets/icons/dashboard/survey_icon.svg'} width='18px' height='18px' />
                  </Tooltip>
                )}
                {item.title === 'participants' && <img src={'/assets/icons/dashboard/group_icon.svg'} width='18px' height='18px' />}
                {(item.title !== 'survey' && item.title !== 'participants') && item.title}
              </div>
            ) : (
              <div
                key={index}
                style={{ width: item.width, textAlign:"left" }}
                className={clsx(classes.cursor)}
                onClick={() => (index !== 0 && !sub && !search && !isMobile) && onClickFilter(index)}
              >
                {!sub ? (
                  <TableSortLabel
                    style={{ color: filter === item.title ?'#017AEF':'' }}
                    active={filter === item.title}
                    direction={filter === item.title ? 'desc' : 'asc'}
                    onClick={() => (!isMobile && onClickFilter) && onClickFilter(index)}
                    IconComponent={()=>CustomSortIconComponent(filterDirection,filter,item.title)}
                  >
                    {item.title}
                    {filter === item.title ? (
                      <span className={classes.visuallyHidden}>
                      {filterDirection ? 'sorted descending' : 'sorted ascending'}
                    </span>
                    ) : null}
                  </TableSortLabel>
                ) : (
                  <span>{item.title}</span>
                )}
              </div>
            )
          )
        }
      </div>
    </div>
  )
}